import { render, staticRenderFns } from "./CodeEmbed.vue?vue&type=template&id=c45273d0&scoped=true&"
import script from "./CodeEmbed.vue?vue&type=script&lang=js&"
export * from "./CodeEmbed.vue?vue&type=script&lang=js&"
import style0 from "./CodeEmbed.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CodeEmbed.vue?vue&type=style&index=1&id=c45273d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45273d0",
  null
  
)

export default component.exports